var map = {
	"./customer-average.csv": 605,
	"./customer-east.csv": 606,
	"./customer-london.csv": 607,
	"./customer-satisfaction.csv": 608,
	"./customer-south-east.csv": 609,
	"./domestic-charges.csv": 610,
	"./duration-power.csv": 611,
	"./financial-east.csv": 243,
	"./financial-london.csv": 244,
	"./financial-south-east.csv": 245,
	"./focus-1.csv": 612,
	"./focus-2.csv": 613,
	"./focus-5.csv": 614,
	"./frequency-power.csv": 615,
	"./interuptions-average.csv": 616,
	"./interuptions-east.csv": 617,
	"./interuptions-london.csv": 618,
	"./interuptions-south-east.csv": 619,
	"./lost-time.csv": 620,
	"./minutes-average.csv": 621,
	"./minutes-east.csv": 622,
	"./minutes-london.csv": 623,
	"./minutes-south-east.csv": 624
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 857;


//////////////////
// WEBPACK FOOTER
// ./src/assets/data ^\.\/.*\.csv$
// module id = 857
// module chunks = 0